export function checkTokenExpired(token) {
	if (!token) return true

	try {
		const payloadBase64 = token.split('.')[1]
		if (!payloadBase64) return true

		const decodedPayload = JSON.parse(atob(payloadBase64))

		const expiry = decodedPayload.exp
		if (!expiry) return true

		const now = Math.floor(Date.now() / 1000)
		return expiry < now
	} catch (error) {
		console.error('Erro ao validar token:', error)
		return true
	}
}
